import { motion, useAnimation, useInView } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import { ThemeContext } from "../../contexts/ThemeProvider";
const FeaturedButton = ({
  index,
  trigger,
  label,
  top,
  bottom,
  left,
  right,
  onClick,
  icon,
}: {
  index: number;
  trigger: boolean;
  label: string;
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
  icon?: React.ReactNode;
  onClick: () => void;
}) => {
  const ref = useRef<HTMLButtonElement>(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();
  const { colorsObj } = useContext(ThemeContext);
  useEffect(() => {
    if (isInView) {
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay: index * 0.1 },
      });
    }
    // eslint-disable-next-line
  }, [isInView]);

  useEffect(() => {
    controls.start({
      boxShadow: trigger
        ? `0 4px 20px ${colorsObj.colorPrimary + "30"}`
        : "none",
      transition: { duration: 0.2, ease: "easeInOut" },
    });
    // eslint-disable-next-line
  }, [trigger]);

  const isMobile = window.innerWidth < 640;

  return (
    <motion.button
      className="z-20 flex items-center justify-center gap-2 w-28 scale-110"
      style={
        trigger
          ? {
              scale: isMobile ? 0.8 : 1,
              position: "absolute",
              backgroundColor: colorsObj.colorSecondary,
              top: top,
              bottom: bottom,
              left: left,
              right: right,
              padding: "8px 8px",
              borderColor: "#238f9fff",
              borderWidth: 0.5,
              borderRadius: "10px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }
          : {
              scale: isMobile ? 0.8 : 1,
              position: "absolute",
              padding: "8px 8px",
              borderRadius: "10px",
              top: top,
              bottom: bottom,
              left: left,
              right: right,
              backgroundColor: colorsObj.colorPrimary,
            }
      }
      initial={{ opacity: 0, y: 20 }}
      ref={ref}
      animate={controls}
      onClick={onClick}
    >
      <>{icon}</> {label}
    </motion.button>
  );
};

export default FeaturedButton;
